import { combineReducers } from "redux";
import auth from "./auth";
import cards from "./cards";
 import alert from "./alert";
import orders from "./orders";
export default combineReducers({
   alert,
  auth,
 cards,
 orders,
});